import React from 'react';
import { Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PolicyCard } from '../../Shared';

/**
 * PublicPolicies - List of public policies (metadata only)
 * @param {Array} policies - Array of policy objects
 */
export const PublicPolicies = ({ policies = [] }) => {
  const { t } = useTranslation('transparency');
  if (!policies || policies.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('public.emptyPolicies')}
      </Typography>
    );
  }

  return (
    <Grid container spacing={2}>
      {policies.map((policy, index) => (
        <Grid item xs={12} sm={6} key={policy.id || index}>
          <PolicyCard
            name={policy.title}
            version={policy.version}
            status={policy.status}
            visibility="public"
            lastUpdated={policy.lastUpdated}
          />
        </Grid>
      ))}
    </Grid>
  );
};
